/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ agency: NonNullable<unknown> }} Portalsignin_TitleInputs */

const en_portalsignin_title = /** @type {(inputs: Portalsignin_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sign in to ${i?.agency}`)
};

/**
* | output |
* | --- |
* | "Sign in to {agency}" |
*
* @param {Portalsignin_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portalsignin_title = /** @type {((inputs: Portalsignin_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_TitleInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_portalsignin_title(inputs)
});